import React from 'react'
const VKcontext = React.createContext();

 export default VKcontext